import script from "./CEmployeeCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CEmployeeCard.vue?vue&type=script&lang=ts&setup=true"

import "./CEmployeeCard.vue?vue&type=style&index=0&id=a3e8add4&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CEmployeeCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3e8add4"]])

export default __exports__